import CFG from 'config'
import React, { Component } from "react";
import "./orderlist.scss";

import ReactResizeDetector from "react-resize-detector";
import axios from "axios";
import moment from "moment";
import lowerCase from "lodash/lowerCase";
import capitalize from "lodash/capitalize";

import { AutoSizer, Column, Table } from "react-virtualized";
import "react-virtualized/styles.css";
import Tooltip from "react-tooltip-lite";

// components
import Loader from "../components/Loader/Loader";
import Filters, { LABEL_STATUS_AGENCY } from "../components/Filters/Filters";

// assets
import { ReactComponent as OrderIcon } from "./assets/images/order-link.svg";
import { ReactComponent as DownloadIcon } from "./assets/images/download-icon.svg";

// Download data
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ReactExport from "react-data-export";
import { getQs } from 'services/queryString'
import $t from 'services/i18n'

import { formatOrder, formatCSVColumns, getOrderId } from 'services/map'

const getRequest = (entity, id, queryString) => {
  const { host, endpoint } = CFG.api.order;
  let url;
  if (entity === "affiliate") {
    url = `${host}/${endpoint[entity]}?uuidAffiliate=${id}${queryString}`;
  } else if (entity === "supplier") {
    const queryWithId=`uuidSupplier='${id}'${queryString}`;
    url = `${host}/${endpoint[entity]}?${queryToFilter(queryWithId)}`;
  } else if (entity === "agent") {
    url = `${host}/${endpoint}?ulEmailAgent=${id}${queryString}`;
  } else {
    throw new Error(`Entity "${entity}" not recognized`);
  }
  const token = getQs("token")
  return axios.get(
    url,
    token
      ? {
          headers: { authorization: `Bearer ${getQs("token")}`, "x-musement-version": "3.4.0" },
        }
      : undefined
  );
};

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const statusFilter = {
  PENDING: "waiting",
  BOOKING_CONFIRMED: "success",
  NEEDS_CONFIRM: "waiting",
  CONFIRM_REFUSED: "refused",
  CONFIRMATION_REFUSED: "refused",
  PARTLY_REFUNDED: "refused",
  "PARTIALLY REFUNDED": "refused",
  REFUNDED: "success",
  TOTALLY_REFUNDED: "success",
  IN_BOOKING: "waiting",
  WAITING_CONFIRM: "waiting"
};

const COLUMN_LABEL_AGENCY = {
  'Order': 'orderstable.booking.number',
  'BookingDate': 'orderstable.confirmation.date',
  'ProductDate': 'orderstable.service.date',
  'Product': 'order.property.activity.title',
  'Holder': 'order.property.holder',
  'RetailPrice': 'orderstable.totalprice',
  'LastName': 'order.property.lastname',
  'Email': 'order.property.email',
  'Status': 'common.label.status'
}

const queryToFilter = (query) => {
  let data = query.split('&');
  return (encodeURI("filter=(" + data.join(') AND (') + ")" ));
}

class OrderList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      orders: [],
      ordersRowColors: [],
      csvDataset: [],
      xlsDataset: [],
      orderDesc: false,
      apiError: false,
      // path and params
      apiPath: null,
      id: null,
      queryString: "",
      // ui
      showDownloadMenu: false,
      savingFile: false,
      omitClickEvent: false
    };

    const { entity } = this.props; // affiliate/seller/supplier

    this.formatOrder = formatOrder[entity]
    this.formatCSVColumns = formatCSVColumns[entity]

    this.headerRender = this.headerRender.bind(this);
    this.cellRender = this.cellRender.bind(this);

    this.onDownloadMenuClickOutside = this.onDownloadMenuClickOutside.bind(
      this
    );

    this.updateFilters = this.updateFilters.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  componentWillMount() {
    const {
      path,
      params: { id }
    } = this.props.match;
    const { search } = this.props.location;
    const omitClickEvent = !!search.match("omitClickEvent");
    this.setState({ apiPath: path, id, omitClickEvent });
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.onDownloadMenuClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.onDownloadMenuClickOutside);
  }

  onResize(width, height) {
    window.parent.postMessage(`iframeheight-${height}`, "*");
  }

  updateFilters(queryString) {
    if (queryString !== this.state.queryString) {
      this.setState({ queryString }, () => {
        const { apiPath, id, queryString } = this.state;
        // console.log('updateFilters', queryString);
        if (id && apiPath) {
          this.setState({ loading: true }, () => {
            const request = getRequest(this.props.entity, id, queryString);
            if (request) {
              request.then(res => {
                if (res && res.status === 200) {
                  const data = res.data.hasOwnProperty('resource') ? res.data.resource : res.data 
                  const formattedOrders = data
                    .map(this.formatOrder)
                    .sort((a, b) => {
                      return a.Order.value > b.Order.value;
                    });
                  let firstColor = "#ffffff";
                  let secondColor = "#f1f1f1";
                  let swapColor = false;
                  const ordersRowColors = formattedOrders.map((o, i) => {
                    const prevOrder = i > 0 ? formattedOrders[i - 1] : null;
                    if (prevOrder) {
                      if (prevOrder.Order.value !== o.Order.value) {
                        swapColor = !swapColor;
                      }
                    }
                    const rowColor = !swapColor ? firstColor : secondColor;
                    return rowColor;
                  });

                  const documentFormattedOrders = data
                  ? this.formatCSVColumns(data)
                  : [];
                  this.setState({
                    loading: false,
                    apiError: false,
                    orders: formattedOrders || [],
                    ordersRowColors,
                    xlsDataset: documentFormattedOrders
                      ? this.ordersToXlsxDataset(documentFormattedOrders)
                      : [],
                    csvDataset: documentFormattedOrders || []
                  });
                } else {
                  this.setState({ loading: false, apiError: true });
                }
              });
            }
          });
        }
      });
    }
  }

  onDownloadMenuClickOutside(event) {
    if (this.downloadMenuRef && !this.downloadMenuRef.contains(event.target)) {
      this.setState({ showDownloadMenu: false });
    }
  }

  ordersToXlsxDataset(orders) {
    if (!orders || orders.length === 0) return [];
    const columns = Object.keys(orders[0]).filter(e => e !== "Commissions" && e !== "RetailPrice");    
    const dataset = [
      {
        columns,
        data: orders.map(s => {
          const entries = Object.entries(s)  
          
          return entries.reduce((acc, [key, value]) => {
            if(key !== "Commissions" && key !== "RetailPrice") {
              if(key === "NetPrice") acc.push(s.Status === 'BOOKING_CONFIRMED' ? parseFloat(value): '')
              else if(key === "Tickets") acc.push(parseFloat(value))
              else acc.push(value)
            }
            return acc;
          }, []);
        })
      }
    ];
    return dataset;
  }

  orderByFilter(label) {
    const { orders, orderDesc } = this.state;
    const orderedOrders = orders;
    orderedOrders.sort((a, b) => {
      if (a[label].isDate) {
        if (orderDesc)
          return new Date(a[label].value) - new Date(b[label].value);
        return new Date(b[label].value) - new Date(a[label].value);
      } else {
        if (orderDesc) return a[label].value - b[label].value;
        return b[label].value - a[label].value;
      }
    });

    this.setState({ orders: orderedOrders, orderDesc: !orderDesc });
  }

  downloadAsPDF(entity, id) {
    this.setState({ savingFile: true }, () => {
      document.body.style.overflow = "hidden";
      const input = document.getElementById("dataTable");
      console.log("input", input);
      html2canvas(input).then(canvas => {
        console.log("canvas", canvas);
        const imgData = canvas.toDataURL("image/png");
        console.log("imgData", imgData);
        var imgWidth = 210;
        var pageHeight = 280;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;
        var doc = new jsPDF("p", "mm", "a4");
        var position = 0;
        doc.addImage(imgData, "png", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        this.setState({ savingFile: false }, () => {
          doc.save(`${entity}-${id}.pdf`);
          document.body.style.overflow = "auto";
        });
      });
    });
  }

  openOrder(data) {
    const { sendObject } = this.props;
    if (sendObject) {
      window.parent.postMessage({id: data.value, uuid: data.uuid}, "*");
    } else {
      window.parent.postMessage(`order-${data.value}`, "*");
    }
  }

  // UI

  statusRender(cellData) {
    // BOOKING_CONFIRMED/CONFIRMATION_REFUSED
    const tooltipMessage = capitalize(lowerCase(cellData.value));
    const cssStatus = statusFilter[cellData.value];

    const inner = this.props.entity === 'agent' ? <div className={`orderlist-tablecolumn`} > {$t(LABEL_STATUS_AGENCY[cellData.value])} </div>
      : <Tooltip content={tooltipMessage}>
      <div
        className={`orderlist-tablecolumn-status orderlist-tablecolumn-status--${cssStatus}`}
      />
    </Tooltip>

    return (
      <div className="orderlist-tablecolumn">
        {inner}
      </div>
    );
  }

  linkRender(cellData) {
    const { omitClickEvent } = this.state;
    const className = `orderlist-tablecolumn${
      omitClickEvent ? "" : " orderlist-tablecolumn-event"
    }`;
    return (
      <div className={className}>
        <div
          className="orderlist-tablecolumn--order"
          onClick={() =>
            omitClickEvent ? undefined : this.openOrder(cellData)
          }
        >
          <OrderIcon />
          {cellData.value ? getOrderId(cellData.value) : "---"}
        </div>
      </div>
    );
  }

  dateRender(cellData) {
    return (
      <div className="orderlist-tablecolumn">
        {moment(cellData.value).format("DD/MM/YYYY")}
      </div>
    );
  }

  headerRender({ label }) {
    return <div className="orderlist-tableheader">{label}</div>;
  }

  cellRender({ cellData }) {
    if (cellData.isStatus) return this.statusRender(cellData);

    if (cellData.isLink) return this.linkRender(cellData);

    if (cellData.isDate) return this.dateRender(cellData);

    return (
      <div className="orderlist-tablecolumn">
        {cellData.isPrice && cellData.value ? `${cellData.currency} ` : ""}
        {cellData.value || "---"}
      </div>
    );
  }

  getTableColumns(column, index, size) {
    return (
      <Column
        key={index}
        label={$t(COLUMN_LABEL_AGENCY[column], {default: column})}
        dataKey={column}
        width={column === "Product" || index === 0 ? 300 : 200}
        headerRenderer={this.headerRender}
        cellRenderer={this.cellRender}
        flexGrow={1}
      />
    );
  }

  getRowStyle(color) {
    return { borderTop: "1px solid #dce4e6", backgroundColor: color };
  }

  render() {
    const {
      loading,
      showDownloadMenu,
      savingFile,
      id,
      orders,
      ordersRowColors,
      csvDataset,
      xlsDataset
    } = this.state;
    const { filterStatus, entity, hideDownloadBtn } = this.props;

    const columns = orders.length >= 1 ? Object.keys(orders[0]) : [];
    const HEADER_HEIGTH = 40;
    const ROW_HEIGTH = 60;
    const TABLE_HEIGHT = getQs('tableHeight') || 800

    return (
      <ReactResizeDetector handleWidth handleHeight onResize={this.onResize}>
        <div className="orderlist">
          {savingFile && <Loader label="Exporting file..." />}
          <Filters
            updateFunction={this.updateFilters}
            filterStatus={filterStatus}
          />
          <div className="orderlist-header">
            <span className="orderlist-header-ordersnumber">{`${
              orders.length
            } orders`}</span>
            {hideDownloadBtn || (
              <div
                className="orderlist-header-exportbutton"
                onClick={() =>
                  this.setState({
                    showDownloadMenu: !this.state.showDownloadMenu
                  })
                }
              >
                <DownloadIcon />
                <span>Download as</span>
              </div>
            )}
            {showDownloadMenu && (
              <div
                className="orderlist-downloadmenu"
                ref={node => (this.downloadMenuRef = node)}
              >
                <CSVLink
                  data={csvDataset}
                  filename={`${entity} -${id}.csv`}
                  target="_blank"
                  onClick={() => {
                    window.parent.postMessage({field: "download_csv"}, "*");
                  }}
                >
                  CSV
                </CSVLink>
                <ExcelFile
                  filename={`${entity}-${id}`}
                  element={
                    <button 
                      onClick={() => {
                        window.parent.postMessage({field: "download_xls"}, "*");
                      }}
                      className="page-downloadmenu--pdf"
                    >
                      XLS
                    </button>
                  }
                >
                  <ExcelSheet dataSet={xlsDataset} name="Report" />
                </ExcelFile>
                {/* <button className="orderlist-downloadmenu--pdf" onClick={() => this.downloadAsPDF(entity, id)}>PDF</button> */}
              </div>
            )}
          </div>
          <div id="dataTable">
            {orders.length >= 1 && !loading && (
              <AutoSizer disableHeight>
                {({ width }) => (
                  <Table
                    width={width}
                    height={TABLE_HEIGHT} // item height === 60px
                    headerHeight={HEADER_HEIGTH}
                    rowHeight={ROW_HEIGTH}
                    rowCount={orders.length}
                    rowGetter={({ index }) => orders[index]}
                    rowStyle={({ index }) =>
                      this.getRowStyle(ordersRowColors[index])
                    }
                    // onRowClick={({ rowData }) => console.log('[OrderList.js ==> row click]', rowData)}
                    onHeaderClick={({ dataKey }) => this.orderByFilter(dataKey)}
                  >
                    {columns.map((c, index) =>
                      this.getTableColumns(c, index, columns.length)
                    )}
                  </Table>
                )}
              </AutoSizer>
            )}
            {loading && <Loader />}
          </div>
        </div>
      </ReactResizeDetector>
    );
  }
}

export default OrderList;
